import { render } from "./protectionBundleSearchCard.vue?vue&type=template&id=8ed6d0a6"
import script from "./protectionBundleSearchCard.vue?vue&type=script&lang=js"
export * from "./protectionBundleSearchCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__